import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-in-retirement-healthcare-expenses',
  templateUrl: './in-retirement-healthcare-expenses.component.html',
  styleUrls: ['./in-retirement-healthcare-expenses.component.scss']
})
export class InRetirementHealthcareExpensesComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<InRetirementHealthcareExpensesComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
